export default __webpack_public_path__ + "static/media/core_single.b4019cdc.svg";